import { render, staticRenderFns } from "./JudgeResult.vue?vue&type=template&id=f9b077d4&scoped=true&"
import script from "./JudgeResult.vue?vue&type=script&lang=js&"
export * from "./JudgeResult.vue?vue&type=script&lang=js&"
import style0 from "./JudgeResult.vue?vue&type=style&index=0&id=f9b077d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b077d4",
  null
  
)

export default component.exports